import { startCase } from "lodash";
import React, { useEffect } from "react";

import { ResolveUsers } from "../organizations/IdentityAPI";

export interface IAccessLevel {
    level: number;
    name: string;
}

const UserRenderer = ({ subjectID }: { subjectID: string }) => {
    const [value, setValue] = React.useState(subjectID);

    const setValueToUserName = async (id) => {
        let users = await ResolveUsers([id]);
        if (users.length > 0) {
            setValue(users[0].displayName + " (" + users[0].email + ")");
        }
    };

    useEffect(() => {
        setValueToUserName(subjectID);
    }, [subjectID]);

    return <>{value}</>;
};

export default UserRenderer;
